
import React, { useState, useEffect } from "react";
import { FaSearch, FaMapMarkerAlt } from "react-icons/fa";
import "./SearchBar.css";

const SearchBar = ({
  searchText,
  provinceId,
  onSearchTextChange,
  onProvinceChange,
}) => {
  const [provinces, setProvinces] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchProvinces = async () => {
      try {
        const response = await fetch(
          "https://iudi-api.thinkdiff.us/api/districts"
        );
        const result = await response.json();

        // Get districts array from response
        let districts = [];
        if (Array.isArray(result)) {
          districts = result;
        } else if (result && Array.isArray(result.data)) {
          districts = result.data;
        }

        // Extract unique provinces from districts
        const provinceMap = new Map();
        districts.forEach(district => {
          if (district.ProvinceID && district.ProvinceName) {
            if (!provinceMap.has(district.ProvinceID)) {
              provinceMap.set(district.ProvinceID, {
                ProvinceID: district.ProvinceID,
                ProvinceName: district.ProvinceName
              });
            }
          }
        });

        // Convert Map to array and sort by ProvinceName
        const uniqueProvinces = Array.from(provinceMap.values()).sort((a, b) =>
          a.ProvinceName.localeCompare(b.ProvinceName, 'vi')
        );

        setProvinces(uniqueProvinces);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching provinces:", error);
        setProvinces([]);
        setLoading(false);
      }
    };

    fetchProvinces();
  }, []);

  return (
    <form className="search-bar-form" onSubmit={(e) => e.preventDefault()}>
      <div className="search-input-wrapper product-search">
        <FaSearch className="search-icon" />
        <input
          type="text"
          placeholder="Tìm sản phẩm"
          className="search-input"
          value={searchText}
          onChange={(e) => onSearchTextChange?.(e.target.value)}
        />
      </div>
      <div className="search-input-wrapper location-search">
        <FaMapMarkerAlt className="search-icon" />
        <select
          className="search-input search-select"
          value={provinceId || ""}
          onChange={(e) => onProvinceChange?.(e.target.value)}
          disabled={loading}
        >
          <option value="">Tất cả tỉnh/thành phố</option>
          {provinces.map((province) => (
            <option key={province.ProvinceID} value={province.ProvinceID}>
              {province.ProvinceName}
            </option>
          ))}
        </select>
      </div>
      <button type="submit" className="search-submit-btn">
        Tìm kiếm
      </button>
    </form>
  );
};

export default SearchBar;
